import AService from '@/services/AService'

export default class AddressService extends AService {

  /**
   * Call the address resolution API with the input address
   */
  async searchByAddress(address) {
    const response = await this.http.get(`${this.baseUrl}/geocodage/search?q=${address}`);
    return response.data;
  }
}

